import { MembersListsForUpdate } from 'components/EmployeeGroups/types';

import { SignerReviewerGroup } from '../types/user';

import graph from './graph';
import io from './io';

export const createEmployeeGroup = async (config: { name: string }) => {
    return await io.post('/internal-api/groups', config, true);
};

export const updateEmployeeGroup = async (config: {
    name: string;
    employeeGroupId: string;
}) => {
    return await io.patch(
        `/internal-api/groups/${config.employeeGroupId}`,
        config,
    );
};

export const getEmployeeGroups = async (config: {
    name?: string;
    limit?: number;
    offset?: number;
}): Promise<SignerReviewerGroup[]> => {
    const {
        allGroups: { groups },
    } = await graph.get(`
        {
            allGroups${graph.formatArguments(config)} {
                groups {
                    id
                    name
                    members {
                        id
                        role {
                            id
                            user {
                                email
                                firstName
                                secondName
                                lastName
                            }
                        }
                    }
                }
            }
        }
    `);
    return groups;
};

export const getGroupsCount = async (config: { name?: string }) => {
    const {
        allGroups: { count },
    } = await graph.get(`
        {
            allGroups${graph.formatArguments(config)} {
                count
            }
        }
    `);
    return count;
};

export const addEmployeeGroupMembers = async (
    employeeGroupId: string,
    roleIds: MembersListsForUpdate['membersToAdd'],
) => {
    return await io.post(`/internal-api/groups/${employeeGroupId}/members`, {
        role_ids: roleIds,
    });
};

export const deleteEmployeeGroup = async (employeeGroupId: string) => {
    return await io.delete(`/internal-api/groups/${employeeGroupId}`);
};

export const deleteEmployeeGroupMembers = async (
    employeeGroupId: string,
    memberIds: MembersListsForUpdate['membersToDelete'],
) => {
    return await io.post(
        `/internal-api/groups/${employeeGroupId}/members/remove`,
        {
            group_members: memberIds,
        },
    );
};

export const getEmployeeGroup = async (employeeGroupId: string) => {
    const { group } = await graph.get(`
        {
            group${graph.formatArguments({ id: employeeGroupId })}  {
                id
                name
                members {
                    id
                    role {
                        id
                        isAdmin
                        user {
                            email
                            firstName
                            secondName
                            lastName
                        }
                    }
                }
            }
        }
    `);
    return group;
};

export const getEmployeeGroupParticipate = async (employeeGroupId: string) => {
    const { group } = await graph.get(`
    {
        group${graph.formatArguments({ id: employeeGroupId })} {
            id
            documentSigners {
                id
                title
            }
            documentReviewers {
                id
                title
            }
            documentAutomationTemplates {
                id
                name
            }
        }
    }`);
    return group;
};
